import { useState } from 'react';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { getSocket } from '../context/socket';
import { useAuth } from '../context/AuthContext';

const EstimatedHoursPopup = ({ onCancel, cardDetails, togglePopup, cardId, boardId }) => {
    const socket = getSocket();
    const { userId } = useAuth();
    const [hours, setHours] = useState(
        cardDetails?.estimated_hours != null ? Number(cardDetails.estimated_hours) : null
    );

    const handleSave = () => {
        if (!cardId || !boardId) return;

        socket.emit('updateCardEstimatedHours', {
            card_id: cardId,
            estimated_hours: hours,
            board_id: boardId,
            user_id: userId,
        });

        onCancel();
    };

    return (
        <div className="popup-box popup-estimated-hours">
            <div className="popup-header">
                Estimated hours
                <Button
                    icon="pi pi-times"
                    className="p-button-text close-btn"
                    onClick={() => togglePopup('estimated_hours')}
                />
            </div>
            <div className="popup-body">
                <p className="text-muted small mb-2">
                    Daily capacity is 8h. Used for Gantt scheduling and overtime conflict detection.
                </p>
                <InputNumber
                    value={hours}
                    onValueChange={(e) => setHours(e.value)}
                    min={0}
                    max={999}
                    minFractionDigits={0}
                    maxFractionDigits={2}
                    placeholder="Hours"
                    className="w-100"
                />
                <Button
                    label="Save"
                    severity="success"
                    className="border-0 py-1 px-3 mt-3 me-2"
                    onClick={handleSave}
                />
            </div>
        </div>
    );
};

export default EstimatedHoursPopup;
